module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": "/policy"
    }
  }, [_vm._v("Policy")]), _vm._v(" | \r\n          "), _c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Terms")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("©2019 Eeshhbeauty. Made with "), _c('a', {
    attrs: {
      "href": "https://www.lookbookgallery.com",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("Gallery")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a2c690"}!./src/pages/MainFooter/template.html
// module id = 193
// module chunks = 1